// Configuración del Centro de Notificaciones: módulos, estados, filtros y
// paginación. Para agregar un estado nuevo basta con añadir una entrada a
// ESTADOS y, si hace falta, una regla en REGLAS_ESTADO.

export const CITY_NAMES = {
  2641: "San Luis Río Colorado",
  700: "Mexicali",
  703: "Tijuana",
  2633: "Puerto Peñasco",
  699: "Ensenada",
};

// Mismos íconos (Font Awesome) que el navbar lateral (VerticalSidebar.jsx).
export const DEPARTAMENTOS = {
  conciliacion: {
    label: "Centro de Conciliación",
    icon: "fa-solid fa-handshake",
    ruta: (id) => `/materias/laboral/centro-conciliacion/${id}`,
  },
  tribunal: {
    label: "Tribunal Laboral",
    icon: "fa-solid fa-gavel",
    ruta: (id) => `/materias/laboral/tribunal/${id}`,
  },
  junta: {
    label: "Junta de Conciliación",
    icon: "fa-solid fa-clipboard-check",
    ruta: (id) => `/materias/laboral/junta-conciliacion/${id}`,
  },
};

export const CATEGORIAS = {
  expediente: "Expedientes (creación/edición)",
  audiencia: "Audiencias",
  convenio: "Pagos de convenio",
  otro: "Otros",
};

// Colores tomados de la tabla de estados aprobada en el mockup. Cada entrada
// lleva ícono y texto: el estado nunca se indica solo con color.
export const ESTADOS = {
  activo: { label: "Activo", bg: "#DCE8F6", color: "#0B4A8A", icon: "fa-solid fa-folder-open" },
  audiencia: { label: "Audiencia", bg: "#DCE8F6", color: "#0B4A8A", icon: "fa-solid fa-calendar-day" },
  audiencia_2: { label: "2da audiencia", bg: "#FFF1C2", color: "#7A5200", icon: "fa-solid fa-calendar-check" },
  audiencia_3: { label: "3ra audiencia", bg: "#FFE6D0", color: "#9C3D07", icon: "fa-solid fa-calendar-days" },
  convenio: { label: "Convenio", bg: "#FDE3E3", color: "#A3151B", icon: "fa-solid fa-handshake" },
  concluido: { label: "Concluido", bg: "#E8EBF0", color: "#3F4856", icon: "fa-solid fa-circle-check" },
  archivo_incomparecencia: {
    label: "Archivo por incomparecencia",
    bg: "#E8EBF0",
    color: "#3F4856",
    icon: "fa-solid fa-user-xmark",
  },
  constancia_no_conciliacion: {
    label: "Constancia de no conciliación",
    bg: "#E8EBF0",
    color: "#3F4856",
    icon: "fa-solid fa-file-circle-xmark",
  },
  cumplimiento: { label: "Cumplimiento", bg: "#DCF5E6", color: "#066A3F", icon: "fa-solid fa-file-circle-check" },
  sin_estado: { label: "Sin estado", bg: "#E8EBF0", color: "#3F4856", icon: "fa-solid fa-circle-question" },
};

// Reglas en orden: la primera cuyo texto (normalizado, sin acentos ni
// mayúsculas) contenga alguna de las frases gana. "cumplimiento" va antes que
// "convenio" porque el estado de BD "cumplimiento_convenio" contiene ambas.
export const REGLAS_ESTADO = [
  { frases: ["cumplimiento"], clave: "cumplimiento" },
  { frases: ["archivo incomparecencia"], clave: "archivo_incomparecencia" },
  { frases: ["no conciliacion"], clave: "constancia_no_conciliacion" },
  { frases: ["convenio"], clave: "convenio" },
  { frases: ["concluido"], clave: "concluido" },
  { frases: ["3ra audiencia", "tercera audiencia"], clave: "audiencia_3" },
  { frases: ["2da audiencia", "segunda audiencia"], clave: "audiencia_2" },
  { frases: ["1ra audiencia", "primera audiencia", "activo"], clave: "activo" },
  { frases: ["audiencia"], clave: "audiencia" },
];

// Tipos de evento para la fila de ráfaga (ícono por tipo de cambio).
export const TIPOS_EVENTO = {
  eliminacion: { icon: "fa-solid fa-trash-can", colorKey: "colorError" },
  alta: { icon: "fa-regular fa-calendar-plus", colorKey: "colorSuccess" },
  edicion: { icon: "fa-solid fa-pen", colorKey: "colorPrimary" },
};

// Ventana para agrupar eventos del mismo usuario sobre el mismo expediente.
export const VENTANA_RAFAGA_MS = 30 * 60 * 1000;

export const PAGE_SIZE = 25;

// Filtro rápido de fecha, debajo del renglón de Módulo/Estado/Tipo/Ciudad.
export const RANGOS_FECHA = [
  { key: "todas", label: "Todas" },
  { key: "hoy", label: "Hoy" },
  { key: "semana", label: "Esta semana" },
  { key: "mes", label: "Este mes" },
  { key: "personalizado", label: "Personalizado" },
];
